import React from 'react'
import { Redirect } from 'react-router-dom'

class TemplateRedirect extends React.PureComponent {
  render() {
    // console.log("this.props")
    // console.log(this.props)
    if (this.props.location && this.props.location.search) {
      const template_id = this.props.location.search.replace('?template_id=', '')
      return <Redirect to={{ pathname: `/tests`, state: {template_id: template_id} }} />
    } else {
      return ''
    }
  }
}

export default TemplateRedirect



// WEBPACK FOOTER //
// ./src/js/components/TemplateRedirect.js